export const EnlacesActionTypes = {
  API_RESPONSE_SUCCESS: '@@enlaces/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@enlaces/API_RESPONSE_ERROR',

  GET_ENLACE: '@@enlaces/GET_ENLACE',
  LIST_ENLACES: '@@enlaces/LIST_ENLACES',
  ADD_ENLACE: '@@enlaces/ADD_ENLACE',
  UPDATE_ENLACE: '@@enlaces/UPDATE_ENLACE',
  DELETE_ENLACE: '@@enlaces/DELETE_ENLACE',

  RESET: '@@enlaces/RESET'
}
